export interface ForbiddenStateProps {
  title?: string;
  message?: string;
  /** The capabilities the screen needed — shown discreetly (mono) for the user/admin. */
  requiredCapabilities?: ReadonlyArray<string>;
}

/**
 * ForbiddenState — one of the 5 mandatory per-screen states (sans-droit). Rendered when an
 * authenticated user lacks a required capability (deny-by-default). NOT a redirect: the user is
 * logged in, they simply may not see this surface.
 */
export function ForbiddenState({
  title = "Accès refusé",
  message = "Vous n'avez pas les droits nécessaires pour accéder à cet écran.",
  requiredCapabilities,
}: ForbiddenStateProps) {
  return (
    <div className="nv-state nv-state--forbidden" role="alert">
      <div className="nv-state__glyph" aria-hidden>
        ⛔
      </div>
      <div className="nv-state__title">{title}</div>
      <p className="nv-state__desc">{message}</p>
      {requiredCapabilities && requiredCapabilities.length > 0 && (
        <p
          className="nv-mono"
          style={{ fontSize: "var(--nv-fs-caption)", color: "var(--nv-steel)" }}
        >
          {requiredCapabilities.join(" · ")}
        </p>
      )}
    </div>
  );
}
